import { useState } from 'react';
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import { StartTrialModal } from '.'
const ActivityTracker = (props) => {
    return (
        <>
         <section className="bannerAreaN greyBackgroundN BannerDeatils greyBackground">
             <div className="detailsPageSection">
                <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_1440,h_600/VantageFit/NewWebsite/pageBanner__compressed.png" alt="corporate wellness" className="img-responsive" width="1440" height="600"/>
             </div>
             <div className="BannerContent">
                 <div className="headingBannerM container customCampaignContainer text-left ">
                    <div className="row">
                        <div className=" col-lg-7 col-xs-12 col-md-7 col-sm-12"> 
                        <h1>Activity Tracker</h1>
                        <p className="colorwhite w7">
                        Immerse yourself in your wellness journey with highly accurate trackers and seamless integration with wearable devices.
                        </p>
                        <div className="mtb25">
                            <a href="/request-demo/" className="vfitwhitecta ">Schedule a Vantage Fit Demo </a>
                        </div>
                        </div>
                        <div className="col-lg-5  col-xs-12 col-md-5 col-sm-12 position" >
                            <img alt="Step challenge" className ="mobileDisplay mobileimageW lozad"  loading = "lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Banner_Images_ActivityTrackers.png" width="525" height="363"/>
                        </div>
                    </div>
                </div>
             </div>

           
        </section>
        <section className="sectionSpacing greyBackgroundN pt-01 useCaseDesktop desktopView">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Features Glance</div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <p className=" text-center title_spc secondarytext">Here’s a quick look at some of the key features of Vantage Fit.</p>
                    </div>
                    <div className="row_elementor features title_spc featuresN " id="featuresN">
                        <div className="col-lg-5 col-md-6 col-xs-12 col-sm-12 left-activity ActivityTracker ">
                            <div data-img="activityN" className="box_item active-sec ">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm weeklystep"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm weeklystep"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="trackertext">Step <br/>Tracker</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Track every step you take with Vantage Fit’s in-app step tracking feature and show off your numbers with your colleagues.</div>
                            </div>
                            <div data-img="calorieN" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm caloriecounterN"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm caloriecounterN"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="trackertext">Calorie <br/>Counter</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Achieve your daily nutritional goals by logging your meals and keeping count of the calories you consume.</div>
                                
                            </div>
                            <div data-img="heartrateN" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm healthcampaignS"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm healthcampaignS"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="trackertext">Heart Rate <br/>Monitor</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Accelerate your wellness efforts by monitoring your heart rate levels and getting more insights into your overall wellbeing.</div>
                                
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-xs-12 col-sm-12 mid-activity hidden-xs hidden-sm">
                            <div id="activityN">
                                <img width="300" height="600" className="mob_image Image-Overlay active-img lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_Steps_Tracker.png" alt="Step challenge" />
                            </div>
                            <div id="calorieN">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_Calorie_Tracker.png" alt="Walkathon" />
                            </div>
                            <div id="heartrateN">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_Heart_rate.png" alt="workplace health campaign" />
                            </div>
                            <div id="moodometerN">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_mood_o_meter.png" alt="Walkathon" />
                            </div>
                            <div id="waterIntake">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_water_intake.png" alt="workplace health campaign" />
                            </div>
                            <div id="health_diary">
                                <img width="300" height="600" className="mob_image Image-Overlay lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_health_diary.png" alt="Walkathon" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 col-xs-12 col-sm-12 right-activity ActivityTracker">
                            <div data-img="moodometerN" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm moodometerN"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm moodometerN"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="moodmeter trackertext">Mood-O-<br/>Meter</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Track your mood every day to understand your mental health better, and live a happier life.</div>
                            </div>
                            <div data-img="waterIntake" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm waterIntake"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm waterIntake"></div>
                                </div>
                                <div className="featurestext">
                                    <div className=" trackertext">Water Intake <br/>Tracker</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Make sure that you are adequately hydrated by logging in every glass of water that you drink throughout the day.</div>
                            </div>
                            <div data-img="health_diary" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm healthDiaryN"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm healthDiaryN"></div>
                                </div>
                                <div className="featurestext">
                                    <div className=" trackertext">Health <br/>Diary</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Keep track of activity and nutrition in one personalized diary for better convenience and ease.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 cta_center">
                    <a className = "starttrailCTa">
                        <div><StartTrialModal /></div>
                    </a></div>
                </div>
            </div>
        </section>
        <section className = "sectionSpacing position usecasemobile mobileview contestchallngM" id="useCasez">
          <div className = "container customCampaignContainer">
            <div className = "row">
              <div className = "col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className = "mainHeadingN ">
                  Features At Glance
                </div>
                <div className = "subHeading">
                  Here’s a quick look at some of the key features of Vantage Fit.
                </div>
              </div>
            </div>
          </div>
           <div className="container customCampaignContainer " id = "useCasesz"> 
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter active">
                      <div className="useCasesBoxes  weeklystep active featuresSpriteM"  attr = "steptracker"> Step Tracker</div>
                    </div>
                  </div>
                <div className="col-lg-12 usecaseDesc active" id = "steptracker">
                    <div className="onlineBox  row column-change  d-flex align_items_center  mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                          Track every step you take with Vantage Fit’s in-app step tracking feature and show off your numbers with your colleagues.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_Steps_Tracker.png" alt = "Corporate wellness" className = "img-responsive lozad" loading = "lazy" width="230" height="460"/>
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes caloriecounterN featuresSpriteM" attr = "caloriecount">Calorie Counter</div>
                  </div>
                </div>
                <div className="col-lg-12 usecaseDesc" id = "caloriecount">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                           Achieve your daily nutritional goals by logging your meals and keeping count of the calories you consume.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/v1607603447/VantageFit/NewWebsite/ActivityTrackers_Calorie_Tracker.png" alt = "corporate wellness program" className = "img-responsive lozad " loading = "lazy"  width="230" height="460"/>
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes featuresSpriteM healthcampaignS " attr = "heartratekathon">Heart Rate Monitor</div>
                  </div>
                </div>
                <div className="col-lg-12 usecaseDesc" id = "heartratekathon">
                    <div className="onlineBox  row column-change   d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                          Accelerate your wellness efforts by monitoring your heart rate levels and getting more insights into your overall wellbeing.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/v1607603447/VantageFit/NewWebsite/ActivityTrackers_Heart_rate.png" alt = "employee wellness" className = "img-responsive lozad" loading = "lazy"  width="230" height="460"/>
                        </div>
                    </div>
                </div>
                 <div className="row innerSpace">
                   <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes moodometerN featuresSpriteM" attr = "mood">Mood-O-Meter</div>
                  </div>
                </div>
                <div className="col-lg-12  usecaseDesc" id = "mood">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                           Track your mood every day to understand your mental health better, and live a happier life.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_mood_o_meter.png" alt = "Employee health" className = "img-responsive lozad" loading = "lazy"  width="230" height="460"/>
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                   <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes waterIntake featuresSpriteM" attr = "waterintake">Water Intake Tracker</div>
                  </div>
                </div>
                <div className="col-lg-12  usecaseDesc" id = "waterintake">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                           Make sure that you are adequately hydrated by logging in every glass of water that you drink throughout the day.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_water_intake.png" alt = "Employee health" className = "img-responsive lozad" loading = "lazy"  width="230" height="460"/>
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                   <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes healthDiaryN featuresSpriteM" attr = "haelthdiary">Health Diary</div>
                  </div>
                </div>
                <div className="col-lg-12  usecaseDesc" id = "haelthdiary">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                          Keep track of activity and nutrition in one personalized diary for better convenience and ease.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/ActivityTrackers_health_diary.png" alt = "Employee health" className = "img-responsive lozad" loading = "lazy"  width="230" height="460"/>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <section className="sectionSpacing ">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Benefits</div>
                    </div>
                </div>
                <div className="row innerSpace  d-flex align-items-center column-change">
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6 featuresNbenefits">
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Give your employees the advantage of being in total control of their health.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Keep employees focused on their health even when no contests are running.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Help your workforce track and monitor their health and achieve their fitness goals.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Increase motivation and encourage competitiveness among your employees.
                            </div>
                        </div>
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Benefitd_Activity_trackers.png" alt="Step challenge" className="img-responsive lozad"  loading = "lazy"  width="530" height="425"/>
                        </div>
                </div>
            </div>
        </section>
         <section className="sectionSpacing featuresDetailsShape">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                        <div className="colorwhite mainHeadingN">Schedule a Vantage Fit Demo</div>
                        <p className="colorwhite">How Corporate Wellness Program can Help Your Organisation</p>
                        <div className="mtb25 cta_center margb"><a href="https://www.vantagefit.io/request-demo/" className="vfitwhitecta ">Schedule a Demo</a></div>
                    </div>
                </div>
            </div>
        </section>
        
        </>
    );
}

export default ActivityTracker;



